"use client";
// components/MapContainer.tsx
import { useQuery } from "@tanstack/react-query";
import { getMapData, getMapClusterData } from "@/app/actions/supabase-actions";
import BigDataMap from "@/components/maps/BigDataMap";
// import { Skeleton } from "../ui/skeleton";
// import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

interface ExportMapData {
  longitude: number;
  latitude: number;
  clusters: number;
}

interface RawMapData {
  longitude: number | null;
  latitude: number | null;
  clusters: number | null;
}

interface ClusterData {
  adjusted_r2: number | null;
  cluster: number | null;
  mse: number | null;
  r2: number | null;
}

export default function MapContainer() {
  const {
    data: mainData,
    error: mainError,
    isLoading: isLoadingMain,
  } = useQuery({
    queryKey: ["mapData"],
    queryFn: () => getMapData(),
  });

  const {
    data: clusterData,
    error: clusterError,
    isLoading: isLoadingCluster,
  } = useQuery({
    queryKey: ["clusterData"],
    queryFn: () => getMapClusterData(),
  });

  if (mainError || clusterError) {
    const error = mainError || clusterError;
    return (
      <div className="error-container">
        <p>Error loading data: {error instanceof Error ? error.message : "Unknown error"}</p>
      </div>
    );
  }

  if (isLoadingMain || isLoadingCluster || !mainData?.data || !clusterData?.data) {
    return (
      <div className="loading-container  w-[80vw] w-max-[600px] h-[100%]">
        <p>Loading...</p>
      </div>
    );
  }

  const validData = mainData.data.filter((item): item is ExportMapData => {
    const isValid = item.longitude !== null && item.latitude !== null && item.clusters !== null;
    if (!isValid) {
    }
    return isValid;
  });

  const validClusterData = clusterData.data.filter(
    (item): item is NonNullable<ClusterData> =>
      item.adjusted_r2 !== null && item.cluster !== null && item.mse !== null && item.r2 !== null
  );
  return <BigDataMap data={validData} clusterData={clusterData.data} />;
}
